import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

interface ArticleCardProps {
  slug: string;
  title: string;
  summary: string;
  category: string;
  author: string;
  date: string;
  readTime: number;
  coverImage: string;
}

export default function ArticleCard({
  slug,
  title,
  summary,
  category: categorySlug,
  author,
  date,
  readTime,
  coverImage,
}: ArticleCardProps) {
  const { t } = useTranslation();

  const categoryObj = categories.find((c) => c.slug === categorySlug);
  const categoryName = categoryObj?.name || categorySlug;

  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300 overflow-hidden cursor-pointer">
      <Link to={`/article/${slug}`} className="block">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={coverImage}
            alt={title}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="p-4 md:p-5">
          <span className="inline-block px-2.5 py-1 rounded-md text-xs font-medium bg-secondary-100 text-secondary-800 mb-3">
            {categoryName}
          </span>
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
            {title}
          </h3>
          <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
            {summary}
          </p>
          <div className="flex items-center justify-between text-xs text-foreground-500">
            <span>{author}</span>
            <div className="flex items-center gap-3">
              <span>{date}</span>
              <span className="flex items-center gap-1">
                <i className="ri-time-line"></i>
                {readTime}{t('minutes_read')}
              </span>
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
}